import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('johnDeereCallbackPage');

    return {
        CONNECTING: t('connecting'),
        ERROR: t('error'),
        TRY_AGAIN: t('tryAgain')
    };
};

export default useTranslation;
